const reviews = (perPage) => ({
  products: null,
  reviews: null,
  pagination: null,
  bottomLine: null,
  averageScore: 0,
  totalReview: '',
  stars: null,
  showReviews: false,
  userProduct: null,
  totalPages: 0,
  currentPage: 1,
  perPage: perPage,
  selectedImage: null,
  selectedImageHeight: 0,
  selectedImageWidth: 0,
  visiblePages: [],
  startPage: 1,
  endPage: 5,
  firstLoad: false,
  imageOrientation: null,
  async init(){
    this.urlParams = new URL(window.location.href)
    this.currentPage = this.urlParams.searchParams.get("page") || 1
    this.firstLoad = true

    await this.fetchReviews()
    this.productId = this.products[0].domainKey || 0
    this.fetchRatingUrl = `https://api-cdn.yotpo.com/v3/storefront/store/CJBGvsqpxYapiJkwgcnUk7DYQG460RzUnrAgvYkw/product/${this.productId}/ratings`
  },
  async fetchReviews() {
    const res = await fetch(`https://api-cdn.yotpo.com/v3/storefront/store/CJBGvsqpxYapiJkwgcnUk7DYQG460RzUnrAgvYkw/reviews?page=${this.currentPage}&perPage=${this.perPage}&sort=date,images,badge,rating`);
    const data = await res.json();

    if (data) {
      this.bottomLine = data.bottomline;
      this.averageScore = Math.floor(this.bottomLine.averageScore * 10) / 10;
      this.products = data.products;
      this.showReviews = true;
      this.totalReviewPagination = this.bottomLine.totalReview;
      this.pagination = data.pagination;
      this.currentPage = data.pagination.page;
      this.perPage = data.pagination.perPage;
      this.totalReview = data.bottomline.totalReview;

      // First, map each review to include its product info
      const enrichedReviews = data.reviews.map(review => {
        const product = this.products.find(p => p.id === review.product_id);
        return { ...review, product };
      });

      // Now detect image orientation for each review's product image
      this.reviews = await Promise.all(
        enrichedReviews.map(review => {
          return new Promise(resolve => {
            const img = new Image();
            img.src = review.product.imageUrl;

            img.onload = () => {
              const orientation = img.naturalWidth > img.naturalHeight ? "landscape" : "portrait";
              resolve({
                ...review,
                product: {
                  ...review.product,
                  orientation,
                },
              });
            };

            img.onerror = () => {
              // Fallback if image fails to load
              resolve({
                ...review,
                product: {
                  ...review.product,
                  orientation: "unknown",
                },
              });
            };
          });
        })
      );

      if (this.firstLoad) {
        this.calculateTotalPages();
        this.updatePagination(this.startPage, this.end);
      }

      this.firstLoad = false;
    }
  },
  async getProductRating() {
    try {
      const response = await fetch(this.fetchRatingUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.bottomline.totalReviews;

    } catch (error) {
      console.error('Error fetching product rating:', error);
      return '';
    }
  },
  calculateTotalPages(){
    this.totalPages = Math.ceil(this.totalReviewPagination / this.perPage)
    if (this.currentPage >= this.totalPages){
      this.currentPage = this.totalPages
      this.fetchReviews()
      this.drawURL()
    }
  },
  setCurrentPage(page){
    this.currentPage = page
    this.drawURL()
    this.fetchReviews()

    if (this.currentPage === this.endPage && this.endPage !== this.totalPages){
      this.endPage = this.endPage + 2
      this.startPage = this.startPage + 2
    }

    if (this.currentPage >= this.totalPages){
      this.endPage = this.totalPages
      this.startPage = this.endPage - 4
    }

    if (this.currentPage <= 1){
      this.endPage = 5
      this.startPage = 1
    }

    if (this.currentPage === this.startPage && this.startPage !== 1){
      this.endPage = this.endPage - 2
      this.startPage = this.startPage - 2
    }

    this.updatePagination(this.startPage, this.endPage)
  },
  updatePagination(start, end) {
    this.visiblePages = []

    if (this.firstLoad){
      if (this.currentPage !== 1){
        this.startPage = this.currentPage - 2
        this.endPage = this.currentPage + 2
      }

      if (this.endPage >= this.totalPages){
        this.endPage = this.totalPages
        this.startPage = this.endPage - 4
      }

      if (this.startPage <= 1){
        this.endPage = 5
        this.startPage = 1
      }
    }else{
      this.startPage = start
      this.endPage = end
    }

    if (this.endPage <= this.totalPages){
      for (let i = this.startPage; i <= this.endPage; i++) {
        if (i > 0){
          this.visiblePages.push(i)
        }
      }
    }

    this.$nextTick(()=>{
      document.querySelectorAll(".pagination-item")
      if (document.querySelectorAll(".pagination-item")){
        document.querySelectorAll(".pagination-item").forEach(item => {
          item.classList.remove("active")
        })
      }
      document.querySelector(`[data-page="${this.currentPage}"]`).classList.add("active")
    })
  },
  drawURL() {
    this.urlParams.searchParams.set("page", this.currentPage)
    history.replaceState(this.currentPage, "page", this.urlParams)
  },
  showSelectedImage(image){
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")
    this.selectedImage = image.original_url
    this.selectedImageHeight= image.image_height
    this.selectedImageWidth= image.image_width
  },
  closeImageModal(){
    this.selectedImage = null
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
  }
})

export default reviews

window.addEventListener("alpine:init", ()=>{
  Alpine.data("reviewsPage", reviews)
})
